export default function ProductSpecificationsData() {
  return {
    video: {
      name: "Learn about the Parts of Medicare",
      link: "https://vimeo.com/369617448/1f7308dc4b"
    },
    image: "product-landing/navi/circle2.png",
    header: "Parts of Medicare",
    specs: [
      {
        title: "Original Medicare",
        text: "Includes Part A, hospital insurance, and Part B, medical insurance",
      },
      {
        title: "Subsidized Private Insurance",
        text: "Includes Part C, Medicare Advantage, and Part D, prescription drug coverage",
      },
      {
        title: "Private Insurance",
        text: "Medicare Supplement",
      },
    ],
    hideNeedsAnalysis: true
  }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Navi/ProductSpecificationsData.js